import { Fragment, useState, useEffect } from "react";

import { useLocation, useRouteMatch } from "react-router-dom";
import Alert from "../../../../../../NewComponents/TypedComponents/Alert/Alert.component";
import { appInsights } from "../../../../../../config/appInsights";
import ToggleTab from "../../../../../../NewComponents/ToggleTab/ToggleTab.component";
import { useBusinessCustomerDetail } from "../../../../../../custom-hooks/useBusinessCustomerDetails";
import { Loader } from "../../../../../../UI/Loaders/Loaders";
import { BusinessTypes } from "../../../../Interfaces";
import PendingUserApprovals from "./Tabs/PendingUserApprovals";
import UserSignatorySetupApproval from "./Tabs/SignatorySetupApprovals";
import UserApprovals from "./Tabs/UserApprovals";
import SignatoryApprovals from "./Tabs/SignatoryApprovals";

const Approvals = () => {
  const [activeTab, setActiveTab] = useState("pending-users-approval");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const match = useRouteMatch();

  const { id } = match.params as { id: number };

  const { state } = useLocation();

  useEffect(() => {
    appInsights.trackPageView({
      name: "Approval/index.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <Fragment>
      {error && <Alert message={error} />}
      {success && <Alert message={success} type="success" />}
      <div className="alignToggleTabItems mb-3 mt-5">
        <ToggleTab
          text="Pending users approval"
          id="pending-users-approval"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Pending Number of Signatories"
          id="pending-signatory-setup"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Users"
          id="users"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Number Of Signatories"
          id="number-of-signatories"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <div className="pl-5 pr-5">
        {(() => {
          switch (activeTab) {
            case "pending-users-approval":
              return <PendingUserApprovals />;

            case "pending-signatory-setup":
              return <UserSignatorySetupApproval />;

            case "users":
              return <UserApprovals />;

            case "number-of-signatories":
              return <SignatoryApprovals />;

            default:
              return null;
          }
        })()}
      </div>
    </Fragment>
  );
};

export default Approvals;
